import { getString } from '@nackle/intl-tools';
import { GOLD_COMPANY_ID } from '../constants';


export const getStringWithFallback = ( label, companyId, isUmbrella ) => {
    if ( !isUmbrella ) {
        return getString( label );
    }
    // nav studio builds in a lot of fallback logic when getting the nav bundle for studios
    // since we're moving away from cmx, don't want to build that into umbrella-studio
    // just account for it here.
    const companyString = getString( label, undefined, { companyId } );
    if ( companyString && !companyString.includes( 'Missing locale value' ) ) {
        return companyString;
    }
    return getString( label, undefined, { companyId: GOLD_COMPANY_ID } );
};